<div class="dialog-container p-4">
	<div class="d-flex justify-content-between align-items-center">
  <h3 class="mb-3 flex-grow-1 text-center">
     {{
      data.type === "resources"
        ? "Edit Resources & Reference Links"
		 : data.type === CourseType.Unit
        ? (data.payload ?.unit_id ? "Edit Unit" : "Add Unit")
        : data.type === CourseType.Topic
          ? (data.payload ?.topic_id ? "Edit Topic" : "Add Topic")
        : "Edit " + data.type
    }}
    <span class="close-btn" (click)="closePostDialog()">
		<img src="assets\images\close_button.svg"></span>
  </h3>
</div>
  <div class="scrollable-content">
  <div
    *ngIf="
      data.type === CourseType.Objectives ||
      data.type === CourseType.Outcome ||
      data.type === CourseType.Weblinks ||
      data.type === CourseType.Textbooks ||
      data.type === CourseType.Unit||
      data.type === CourseType.Topic ||
	  data.type === CourseType.Code ||
	  data.type === CourseType.Course_Title ||
	  data.type === CourseType.Course_Unit_Count ||
	  data.type === CourseType.Course_duration
    "
  >
    <quill-editor
      [(ngModel)]="content"
	    [modules]="{ toolbar: false }"
      class="custom-quill"
      placeholder="Write all {{ data.type }} here"
    ></quill-editor>
  </div>

  <div *ngIf="data.type === CourseType.Unit" class="mb-3 mt-2">
    <label for="durationInput" class="form-label">Enter Total Duration</label>
    <input
      type="text"
      id="unitHours"
      class="form-control"
      placeholder="Enter hours (e.g., 1)"
      [(ngModel)]="unitHours"/>
  </div>
  </div>

  <div class="mt-3">
    <button class="btn-add w-100" (click)="save()">Save Changes</button>
  </div>
</div>